<template>
    <button
        type="button"
        class="mobile-menu-button"
        aria-label="Open navigation menu"
        :aria-expanded="mobileStore.isMobileNavOpen"
        @click="mobileStore.toggleMobileNav"
    >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M3 12H15M3 6H21M3 18H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </button>
</template>

<script setup lang="ts">
import { useMobileStore } from '~/stores/layout/mobile';

const mobileStore = useMobileStore();
</script>

<style lang="scss" scoped>
.mobile-menu-button {
    @apply flex lg:hidden;
    background: none;
    border: none;
    color: var(--ink);
    cursor: pointer;
    // display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    margin-right: 24px;
    transition: background-color 0.2s;

    svg {
        width: 20px;
        height: 20px;
        color: var(--ink-body);
    }

    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }
}
</style>
